import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bibShape } from '@bibliocommons/bc-prop-types';
import { ExpandableList } from '@bibliocommons/expandable';
import FieldValue from 'app/components/bibs/shared/MetadataDisplay/FieldValue';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { bibMetadataEventComposer } from '@bibliocommons/analytics-event-composers';
import Heading from '@bibliocommons/heading';
import AnalyticsConstants from '@bibliocommons/constants-analytics';
import './SubjectAndGenre.scss';

const MAX_ITEMS_DISPLAYED = 3;

const { composeMetadataLinkClickEvent, composeShowMoreEvent } = bibMetadataEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

function handleClickEvent() {
  sendAnalyticsEvents(
    composeMetadataLinkClickEvent({
      fieldName: 'SUBJECT',
      category: 'SUBJECTGENRE',
      gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_ABOUT
    })
  );
}

function handleShowMoreEvent(expanded) {
  sendAnalyticsEvents(composeShowMoreEvent({ expanded }));
}

export default function SubjectAndGenre({ subjectsGenres, bib }) {
  const contentType = bib.getIn(['briefInfo', 'contentType']);
  const acceptedContentTypes = ['NONFICTION', 'GOVERNMENT_DOCUMENTS', 'ARCHIVAL'];
  const showSubjectAndGenre = acceptedContentTypes.includes(contentType);

  if (!subjectsGenres || !subjectsGenres.size || !showSubjectAndGenre) return null;

  function renderItems() {
    const renderFieldValue = value => <FieldValue value={value} handleClick={handleClickEvent} />;
    const getItemKey = item => item.getIn(['primary', 'values', 0]);

    return (
      <ExpandableList
        list={subjectsGenres}
        getItemKey={getItemKey}
        renderItem={renderFieldValue}
        collapseCount={MAX_ITEMS_DISPLAYED}
        expandLinkHref="#show-more-subject"
        handleToggle={handleShowMoreEvent}
        stacked
        textKey="subject_and_genre"
      />
    );
  }

  return (
    <div className="cp-subject-genre">
      <Heading tagName="h3" size="medium" variant>
        <FormattedMessage id="bib_metadata_category_subjectgenre" />
      </Heading>
      {renderItems()}
    </div>
  );
}

SubjectAndGenre.propTypes = {
  subjectsGenres: ImmutablePropTypes.listOf(ImmutablePropTypes.map),
  bib: bibShape.isRequired
};
